module.exports = __webpack_public_path__ + "img/ruban.c7dc00d5.png";